import { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { GlobalProvider } from "./components/contexts/globalContext";
import Login from "./components/pages/Login/Login";
import PasswordReset from "./components/pages/PasswordReset/PasswordReset";
import Signup from "./components/pages/Signup/Signup";
import Verification from "./components/pages/Verification/Verification";
import DashboardRouter from "./components/routers/DashboardRouter/DashboardRouter";
import { axiosRequest } from "./services/httpService/axiosRequest";
import generalInstruction from "./assets/pdf/respinos-general-instruction.pdf";

function App() {
  useEffect(() => {
    axiosRequest.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error.response && error.response.status === 401) {
          window.alert("Maaf sesi anda telah habis");
          sessionStorage.clear();

          window.location.replace("/login");
        }
        return Promise.reject(error);
      }
    );
  }, []);
  return (
    <GlobalProvider>
      <Router>
        <Switch>
          <Route path="/verification" component={Verification} />
          <Route path="/password-reset" component={PasswordReset} />
          <Route path="/login" component={Login} />
          <Route path="/signup" component={Signup} />
          <Route
            path="/instruction"
            component={() => (
              <iframe className="w-full h-screen" src={generalInstruction} />
            )}
          />
          <Route path="/" component={DashboardRouter} />
        </Switch>
      </Router>
    </GlobalProvider>
  );
}

export default App;
